import React, { useState } from 'react';
import Filters from './Filters/Filters';
import FiltersProvider from './Filters/contexts/FiltersContext';
import { Buttons } from './Filters/Buttons';
import { Modal } from '@mui/material';

const ChartsContainer = ({ title, className, children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`${className}`}>
            <FiltersProvider>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}
                >
                    <h2 className="title-dashboards">{title}</h2>
                    <Buttons onClickFilters={() => setOpen(true)} />
                    <Modal open={open} onClose={() => setOpen(false)}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <Filters />
                        </div>
                    </Modal>
                </div>

                <div className="charts-container-dashboards">{children}</div>
            </FiltersProvider>
        </div>
    );
};

export default ChartsContainer;